import { Dialog, Transition } from '@headlessui/react';
import React from 'react';
import { Fragment } from 'react';

export default function ModalGeneric(props: {
  isOpen: boolean;
  closeModal: () => void;
  children: React.ReactNode;
  fullScreen?: boolean;
}) {

  return (
    <>
      <Transition appear show={props.isOpen} as={Fragment}>
        <Dialog
          as='div'
          className="modal-dialog-container"
          onClose={() => props.closeModal()}
        >
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            {/** 
             * Background for Modal 
             * The backdrop goes here so that its opacity and color is animated with the transition
             * */}
            <div className='modal-backdrop' />
          </Transition.Child>
          
          {/** Parent Container for Modal */}
          <div className='modal-parent'>
              <Transition.Child
                as={Fragment}
                enter='ease-out duration-300'
                enterFrom='opacity-0 scale-95'
                enterTo='opacity-100 scale-100'
                leave='ease-in duration-200'
                leaveFrom='opacity-100 scale-100'
                leaveTo='opacity-0 scale-95'
              >
                {/**
                  * This is where the styling happens. A full-screen panel is
                  * sized to the display and lets its content divide up that
                  * space; the default one is sized by its content, which is
                  * what the enquiry and subscribe forms want.
                  */}
                <Dialog.Panel
                  className={
                    props.fullScreen ? 'modal-container-full' : 'modal-container'
                  }
                >
                  {props.children}
                </Dialog.Panel>
              </Transition.Child>
            </div>
        </Dialog>
      </Transition>
    </>
  );
}
